import React from 'react';
import classNames from 'classnames';

import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import styles from './expandButton.scss';

interface ExpandButtonProps {
  collapsed: boolean;
  name?: string;
  onClick: (event: React.SyntheticEvent) => void;
}

const ExpandButton = ({ collapsed, onClick, name = '' }: ExpandButtonProps) => (
  <TextLink
    className={classNames(styles.expandButton, collapsed ? styles.show : styles.hide)}
    underline="always"
    iconRight
    onClick={onClick}
    component="button"
  >
    {`${collapsed ? 'Show' : 'Hide'}${name ? ` ${name}` : ''}`}
  </TextLink>
);

ExpandButton.displayName = 'ExpandButton';

export default ExpandButton;
